<template>
	<div>
		<FormDialog :formObject="formObject" :formInfo="formInfo"></FormDialog>
		<!-- 不打印 -->
		<div class="no-print">
			<el-button type="primary" @click="printTicket">打印</el-button>
		</div>

		<!-- 准考证 -->
		<div ref="ticket" class="admission-ticket">
			<div class="flex" v-for="(item, index) in arr" :key="index">
				<div class="one-student" v-for="(it, ind) in item" :key="ind">
					<div class="t-photo">
						<img v-if="it.image_src" :src="image_url+it.image_src" alt="照片" />
						<div v-else class="photo-placeholder">照片</div>
					</div>
					<table class="t-info">
						<tr>
							<td>{{it.grade_name+it.class_number+"班 "+ it.name}}</td>
						</tr>
						<tr>
							<td>{{it.liaison_man_tele }}</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
		
		<div style="margin-bottom: 20px;">
			<el-pagination @current-change="handleCurrentChange" background layout="total, prev, pager, next"
				:total="page_totle" :page-size="20">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import FormDialog from '../../components/FormDialog.vue'
	import {
		getData
	} from "@/utils/table"
	export default {
		name: 'DtStudent',
		components: {
			FormDialog
		},
		data() {
			return {
				image_url:"https://digital-school-education.oss-cn-shanghai.aliyuncs.com/public/static/student_image/",
				formObject: {},
				formInfo: {},
				formLabelWidth: '110px',
				tableData: [],
				name: "",
				page_totle: 1,
				arr: []
			}
		},
		created() {
			getData(this, "/admin/daystudent/index", {
				page: 1
			}, (data) => {
				this.page_totle = data[0]
				this.tableData = data[1]
				let c=0 //计数
				let r=0 //行数
				this.arr=[]
				for (var i = 0; i < this.tableData.length; i++) {
					if (c==0){
						this.arr[r]=[]
						r++
					}
					this.arr[r-1].push(this.tableData[i])
					c++
					if(c==4){
						c=0
					}
				}
			})
		},
		methods: {
			search() {
				if (this.name == "") {
					this.$message({
						message: '请输入学生姓名',
						type: 'warning'
					})
				} else {
					getData(this, '/admin/student/search', {
						name: this.name,
						page: 1
					}, (data) => {
						this.page_totle = data[0]
						this.tableData = data[1]
						for (var i = 0; i < this.tableData.length; i++) {
							this.tableData[i].school_name = this.tableData[i].class_info.school_name
							this.tableData[i].campus_name = this.tableData[i].class_info.campus_name
							this.tableData[i].level_name = this.tableData[i].class_info.level_name
							this.tableData[i].grade_name = this.tableData[i].class_info.grade_name
						}
					})
				}
			},
			//翻页处理
			handleCurrentChange(val) {
				getData(this, "/admin/daystudent/index", {
					page: val
				}, (data) => {
					this.page_totle = data[0]
					this.tableData = data[1]
					let c=0
					let r=0
					this.arr=[]
					for (var i = 0; i < this.tableData.length; i++) {
						if (c==0){
							this.arr[r]=[]
							r++
						}
						this.arr[r-1].push(this.tableData[i])
						c++
						if(c==4){
							c=0
						}
					}
				})
				console.log(this.arr)
			},
			printTicket() {
				const html = this.$refs.ticket.innerHTML
				const win = window.open('', '_blank')
				win.document.write(`
			        <html>
			          <head>
			            <title>合格考准考证</title>
			            <style>
			              @page {
			                size: A4 portrait;
			                margin: 0mm;
			              }
			              * {
			                box-sizing: border-box;
			                -webkit-print-color-adjust: exact;
			                print-color-adjust: exact;
			              }
			              body {
			                font-family: "Microsoft YaHei", Arial, sans-serif;
			                color: #000;
			                padding: 0;
			                margin: 0;
			              }
						  .admission-ticket {
						  	width: 190mm;
						  	margin: 10mm auto;
						  }
						  .flex{
						  	display: flex;
						  	flex-direction: row;
						  	justify-content: space-around;
						  	align-items: center;
						  }
						  .one-student{
						  	width: 35mm;
						  }
						  .t-title {
						  	text-align: center;
						  	font-size: 18pt;
						  	margin: 6mm 0 8mm;
						  	letter-spacing: 1px;
						  }
						  .t-info {
						  	width: 100%;
						  	border-collapse: collapse;
						  	text-align: center;
						  }
						  .t-info td {
						  	/* border: 1px solid #000; */
						  	padding: 6px 8px;
						  	font-size: 10pt;
						  }
						  .t-photo {
						  	width: 35mm;
						  	height: 43mm;
						  	/* border: 1px solid #000; */
						  	display: flex;
						  	align-items: center;
						  	justify-content: center;
						  	overflow: hidden;
						  }
						  .t-photo img {
						  	width: 100%;
						  	height: 100%;
						  	object-fit: cover;
						  }
						  .photo-placeholder {
						  	color: #999;
						  	font-size: 10pt;
						  }
						  tr,
						  table {
						  	page-break-inside: avoid;
						  }
			              
			            </style>
			          </head>
			          <body>
			            <div class="admission-ticket">${html}</div>
			          </body>
			        </html>
			      `)
				win.document.close()
				win.focus()
				win.onload = () => {
					win.print()
					// win.close()
				}
			}
		}
	}
</script>

<style>
	.admission-ticket {
		width: 190mm;
		margin: 10mm auto;
	}
	.flex{
		display: flex;
		flex-direction: row;
		justify-content: space-around;
		align-items: center;
	}
	.one-student{
		width: 35mm;
	}
	.t-title {
		text-align: center;
		font-size: 18pt;
		margin: 6mm 0 8mm;
		letter-spacing: 1px;
	}
	.t-info {
		width: 100%;
		border-collapse: collapse;
		text-align: center;
	}
	.t-info td {
		/* border: 1px solid #000; */
		padding: 6px 8px;
		font-size: 10pt;
	}
	.t-photo {
		width: 35mm;
		height: 45mm;
		/* border: 1px solid #000; */
		display: flex;
		align-items: center;
		justify-content: center;
		overflow: hidden;
	}
	.t-photo img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
	.photo-placeholder {
		color: #999;
		font-size: 10pt;
	}
	tr,
	table {
		page-break-inside: avoid;
	}
</style>